/**
 * Cart Panel and Toast Notification
 * - Displays a floating cart panel with total price, units, and line items
 * - Shows a toast notification when items are added to cart
 */

(function($) {
  'use strict';

  var cartRequestInProgress = false;
  var lastCartData = null;

  $(document).ready(function() {
    // Initialize cart panel only if elements exist
    var $panel = $('#cart-panel');
    var $toast = $('#cart-toast');
    
    if ($panel.length || $toast.length) {
      updateCartPanel();
    } else {
      return;
    }
    
    // Listen for add to cart events
    $('body').on('ajax:addToCart', function(event) {
      var detail = event.detail || {};
      var response = detail.response;
      var formData = detail.form;
      
      // Get quantity and product info
      var quantity = 1;
      var productTitle = 'Product';
      
      if (formData instanceof FormData) {
        quantity = formData.get('quantity') || 1;
      }
      
      // If response has items, get product title from the first item
      if (response && response.items && response.items.length > 0) {
        var item = response.items[0];
        productTitle = item.product_title || 'Product';
      }
      
      // Show toast notification
      showToastNotification(quantity, productTitle, 'added');
      
      // Update cart panel
      updateCartPanel();
    });
    
    // Listen for delete from cart events
    $('body').on('ajax:deleteCart', function(event) {
      updateCartPanel();
    });
    
    // Listen for cart updates
    $('body').on('cart:updated', function(event) {
      updateCartPanel();
    });
    
    // Listen for drawer:Minicart events
    $('body').on('drawer:Minicart', function(event) {
      updateCartPanel();
    });
    
    // Function to update cart panel
    function updateCartPanel() {
      // Prevent multiple simultaneous requests
      if (cartRequestInProgress) return;
      
      var $totalPrice = $('.cart-panel__total-price');
      var $summaryCount = $('.cart-panel__summary-count');
      var $panel = $('#cart-panel');
      
      // Skip if no cart elements exist
      if (!$totalPrice.length && !$summaryCount.length && !$panel.length) return;
      
      cartRequestInProgress = true;
      
      $.getJSON('/cart.js', function(cart) {
        cartRequestInProgress = false;
        
        if (!cart) return;
        
        // Skip if cart data hasn't changed
        if (lastCartData && JSON.stringify(lastCartData) === JSON.stringify(cart)) {
          return;
        }
        lastCartData = cart;
        
        // Update total price
        if ($totalPrice.length && cart.total_price !== undefined) {
          try {
            var moneyFormat = (typeof theme !== 'undefined' && theme && theme.moneyFormat) ? theme.moneyFormat : "${{amount}}";
            $totalPrice.html(Shopify.formatMoney(cart.total_price, moneyFormat));
          } catch (e) {
            console.error('Error formatting money:', e);
            // Fallback to basic formatting if Shopify.formatMoney fails
            $totalPrice.html('£' + (cart.total_price / 100).toFixed(2));
          }
        }
        
        // Update units and line items count
        if ($summaryCount.length) {
          var itemCount = cart.item_count || 0;
          var lineItems = cart.items ? cart.items.length : 0;
          $summaryCount.html(itemCount + ' Units / ' + lineItems + ' Items');
        }
        
        // Show or hide cart panel based on cart state
        if (cart.item_count > 0) {
          $panel.addClass('is-visible');
        } else {
          $panel.removeClass('is-visible');
        }
        
        // Apply currency conversion if needed - only if Currency app is installed
        if (typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function' && typeof shopCurrency !== 'undefined' && Currency.currentCurrency !== shopCurrency) {
          try {
            Currency.convertAll(shopCurrency, Currency.currentCurrency);
          } catch (e) {
            console.error('Error converting currency:', e);
          }
        }
      }).fail(function() {
        cartRequestInProgress = false;
      });
    }
    
    // Function to show toast notification
    function showToastNotification(quantity, productTitle, action) {
      var $toast = $('#cart-toast');
      var $message = $toast.find('.cart-toast__message');

      
      if (!$toast.length || !$message.length) return;
      
      // Set message text with quantity and product title
      var actionText = action === 'added' ? 'added to cart' : 'updated in cart';
      var messageText = quantity + ' x ' + (productTitle || 'Product') + ' ' + actionText;
      $message.text(messageText);
      
      // Clear any existing timeout
      if (window.toastTimeout) {
        clearTimeout(window.toastTimeout);
      }
      
      // Remove the class first to reset any ongoing animations
      $toast.removeClass('is-visible');
      
      // Force a reflow to ensure the animation plays again
      void $toast[0].offsetWidth;
      
      // Show toast with animation
      $toast.addClass('is-visible');
      
      // Hide toast after 3.5 seconds
      window.toastTimeout = setTimeout(function() {
        $toast.removeClass('is-visible');
      }, 3000);
    }
  });
  
})(window.jQuery || window.Zepto);
